import Icon from '../components/Icon.vue'

Icon.register({
  hippo: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M581.1 96.2c34.1 0.2 58.9 33.7 58.9 67.8v92c0 17.7-14.3 32-32 32v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32h-128v176c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16v-70.8c-32.3 14.4-70.7 22.8-112 22.8s-79.7-8.4-112-22.8v70.8c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16v-240c0-88.4 86-160 192-160 49.2 0 94 15.6 128 41v-49c0-13.3 10.8-24 24-24h16c13.3 0 24 10.7 24 24v13.9c10-3.6 20.7-5.9 32-5.9 39.8 0 74 24.3 88.5 58.8 24.1-9 48.9-26.8 76.6-26.6zM448 176c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/hippo.js
// module id = 1458
// module chunks = 0